export default __webpack_public_path__ + "static/media/rotate_device.2c85a73b.gif";